import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import * as moment from "moment";
import { I18N } from "aurelia-i18n";

@autoinject
export class SensumSoilMoistureChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[1].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp).format("lll"));
				this.chartData.datasets[0].data.push(this.convertTemperature(item.data.temperature));
				this.chartData.datasets[1].data.push(item.data.humidity);
			});
			this.chart.refreshChart();
		}
	}

	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			datasets: [
				{
					label: `Temperature (${this.getTemperatureSymbol()})`,
					backgroundColor: "rgba(0,0,255,0.2)",
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(220,220,220,1)",
					yAxisID: "Temperature",
					data: []
				},
				{
					label: "Humidity (%RH)",
					backgroundColor: "rgba(220,220,220,0.2)",
					borderColor: "rgba(220,220,220,1)",
					pointColor: "rgba(220,220,220,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(151,187,205,1)",
					yAxisID: "Humidity",
					data: []
				}
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						},
					}
				],
				yAxes: [
					{
						id: "Temperature",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Temperature"
						},
						position: "left"
					},
					{
						id: "Humidity",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Humidity"
						},
						position: "right"
					}
				]
			}
		};
	}
}
